module.exports = __webpack_public_path__ + "img/Football Minstrel Show.4376ad2d.png";